import { ButtonColor } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { AngleLeftOutlineIcon } from "../icon/AngleLeftlineIcon";
import { AngleRightOutlineIcon } from "../icon/AngleRightlineIcon";

interface Props {
  page: number;
  totalPage: number;
  plusPage: () => void;
  minusPage: () => void;
}

export const AdminHomeHistoryHeaderButtonGroup: React.FC<Props> = ({
  page,
  totalPage,
  plusPage,
  minusPage,
}) => {
  return (
    <Button.Group>
      <Button
        size="sx"
        color={page === 1 ? "" : ButtonColor.ORIGIN_GRAY}
        onClick={minusPage}
        disabled={page === 1}
      >
        <div className="flex items-center mx-[4px]">
          <AngleLeftOutlineIcon
            size={20}
            color={
              page === 1 ? "text-primary-gray" : "text-semantic-text-secondary"
            }
          />
        </div>
      </Button>
      <Button
        size="sx"
        color={page + 1 > totalPage ? "" : ButtonColor.ORIGIN_GRAY}
        onClick={plusPage}
        disabled={page + 1 > totalPage}
      >
        <div className="flex items-center mx-[4px]">
          <AngleRightOutlineIcon
            size={20}
            color={
              page + 1 > totalPage
                ? "text-primary-gray"
                : "text-semantic-text-secondary"
            }
          />
        </div>
      </Button>
    </Button.Group>
  );
};
